export const articleBreakPoints = [
  {
    breakpoint: 1920,
    settings: {
      slidesToShow: 4,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1536,
    settings: {
      slidesToShow: 3.1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1440,
    settings: {
      slidesToShow: 2.7,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1280,
    settings: {
      slidesToShow: 2.1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 1.8,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 1.5,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 640,
    settings: {
      slidesToShow: 1.2,
      slidesToScroll: 1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 350,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 1,
    },
  },
]

export const aimlBreakPoints = [
  {
    breakpoint: 1920,
    settings: {
      slidesToShow: 4.8,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1536,
    settings: {
      slidesToShow: 4.2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1440,
    settings: {
      slidesToShow: 3.5,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1280,
    settings: {
      slidesToShow: 3,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 2.8,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 2.2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 640,
    settings: {
      slidesToShow: 2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1.2,
      initialSlide: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 350,
    settings: {
      slidesToShow: 1.1,
      initialSlide: 1,
      slidesToScroll: 1,
    },
  },
]
export const brandsBreakPoints = [
  {
    breakpoint: 1920,
    settings: {
      slidesToShow: 4.8,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1536,
    settings: {
      slidesToShow: 4.2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1440,
    settings: {
      slidesToShow: 3.8,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1280,
    settings: {
      slidesToShow: 3.4,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 3.2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 2.9,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 640,
    settings: {
      slidesToShow: 2.6,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 2.1,
      initialSlide: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 350,
    settings: {
      slidesToShow: 1.8,
      initialSlide: 0,
      slidesToScroll: 1,
    },
  },
]
export const solutionBreakPoints = [
  {
    breakpoint: 1920,
    settings: {
      slidesToShow: 3.8,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1536,
    settings: {
      slidesToShow: 3.2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1440,
    settings: {
      slidesToShow: 3,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1280,
    settings: {
      slidesToShow: 3,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 2.8,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 2.2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 640,
    settings: {
      slidesToShow: 2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1.2,
      initialSlide: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 350,
    settings: {
      slidesToShow: 1.1,
      initialSlide: 1,
      slidesToScroll: 1,
    },
  },
]

export const projectsBreakPoints = [
  {
    breakpoint: 1920,
    settings: {
      slidesToShow: 4.8,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1536,
    settings: {
      slidesToShow: 4.2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1440,
    settings: {
      slidesToShow: 3.5,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1280,
    settings: {
      slidesToShow: 3,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 2.8,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 2.2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 640,
    settings: {
      slidesToShow: 2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 2.2,
      initialSlide: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 350,
    settings: {
      slidesToShow: 1.8,
      initialSlide: 1,
      slidesToScroll: 1,
    },
  },
]
export const clientsBreakPoints = [
  {
    breakpoint: 1920,
    settings: {
      slidesToShow: 2.4,
    },
  },
  {
    breakpoint: 1536,
    settings: {
      slidesToShow: 2.1,
    },
  },
  {
    breakpoint: 1440,
    settings: {
      slidesToShow: 2.1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1280,
    settings: {
      slidesToShow: 1.6,
    },
  },
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 1.4,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 1.2,
    },
  },
  {
    breakpoint: 640,
    settings: {
      slidesToShow: 1.2,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
    },
  },
  {
    breakpoint: 350,
    settings: {
      slidesToShow: 1,
    },
  },
]
export const coreTeamsBreakPoints = [
  {
    breakpoint: 1920,
    settings: {
      slidesToShow: 3,
    },
  },
  {
    breakpoint: 1536,
    settings: {
      slidesToShow: 1.8,
    },
  },
  {
    breakpoint: 1440,
    settings: {
      slidesToShow: 1.7,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1280,
    settings: {
      slidesToShow: 1.6,
    },
  },
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 1.5,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 1.3,
    },
  },
  {
    breakpoint: 640,
    settings: {
      slidesToShow: 1.2,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
    },
  },
  {
    breakpoint: 350,
    settings: {
      slidesToShow: 1,
    },
  },
]
